// import Footer from "../footer/Footer";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../../../Loading/LoadingSpinner";
import HeaderCargo from "../../cargo/header/Header";
import Toast from "../../../Modals/toast/Toast";

export default function CargoLayout({ children }) {
  return (
    <>
    <div className="w-screen">
    <Toast></Toast>

      <HeaderCargo/>
      <LoadingSpinner></LoadingSpinner>
      <Outlet />
      {/* <Footer /> */}
      </div>
 
    </>
  );
}